// Slice RTK per le date "global" della UI calendar/timeline.
//
// Tengo 4 slice separate per chiave di stato (non un blocco unico) per
// **preservare la legacy state shape** — i consumer leggono `state.calendarDate`,
// `state.begin_date_calendar`, `state.start_timeline`, `state.end_timeline` e
// dispatchano setter individuali. Cambiare lo shape comporterebbe audit di
// decine di file. Vedi cdiFiltersSlice.js per il pattern generale.

import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

// --- calendarDate -----------------------------------------------------------
const calendarDateSlice = createSlice({
  name: 'calendarDate',
  initialState: null,
  reducers: {
    set: (_state, action) => action.payload ?? null,
  },
});
export const { set: setCalendarDate } = calendarDateSlice.actions;
export const calendarDateReducer = calendarDateSlice.reducer;

// --- begin_date_calendar ---------------------------------------------------
const beginDateCalendarSlice = createSlice({
  name: 'begin_date_calendar',
  initialState: dayjs().format('YYYY-MM-DD') + ' 00:00:01',
  reducers: {
    set: (_state, action) => action.payload,
  },
});
export const { set: setBeginDateCalendar } = beginDateCalendarSlice.actions;
export const beginDateCalendarReducer = beginDateCalendarSlice.reducer;

// --- start_timeline ---------------------------------------------------------
// Initial state: Date object (compat con legacy). Setter accetta Date / dayjs
// / string e lascia al consumer la responsabilità del formato.
const startTimelineSlice = createSlice({
  name: 'start_timeline',
  initialState: dayjs().add(-5, 'hour').toDate(),
  reducers: {
    set: (_state, action) => action.payload,
  },
});
export const { set: setStartTimeline } = startTimelineSlice.actions;
export const startTimelineReducer = startTimelineSlice.reducer;

// --- end_timeline -----------------------------------------------------------
const endTimelineSlice = createSlice({
  name: 'end_timeline',
  initialState: dayjs().add(5, 'hour').toDate(),
  reducers: {
    set: (_state, action) => action.payload,
  },
});
export const { set: setEndTimeline } = endTimelineSlice.actions;
export const endTimelineReducer = endTimelineSlice.reducer;
